export const SM_DEVICEID = 'smDeviceId';
export const TD_BLACKBOX = 'tdBlackbox';
